import React, { useState, useEffect } from 'react';

const FighterList = () => {
    const [fighters, setFighters] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchFighters = () => {
        setLoading(true);
        fetch('/api/admin/fighters')
            .then(res => res.json())
            .then(data => {
                setFighters(data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    useEffect(() => {
        fetchFighters();
    }, []);

    if (loading) return <div className="loader">FETCHING WARRIORS...</div>;

    return (
        <div className="fighter-list-admin">
            <div className="admin-header">
                <h3>REGISTERED ({fighters.length})</h3>
                <button onClick={fetchFighters} className="refresh-btn">↻</button>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Style</th>
                        <th>KG</th>
                    </tr>
                </thead>
                <tbody>
                    {fighters.map((f, i) => (
                        <tr key={i}>
                            <td>{f.name}</td>
                            <td className="dim">{f.style}</td>
                            <td>{f.weight}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default FighterList;